module.exports = __webpack_public_path__ + "img/DGER.f5ae9cd1.jpg";